import {PermissionArea} from '../enums/permission-area.enum';


type PathFunction = (payload: any) => string | any[];

export class NavItem {
    code?: string;
    description?: string;
    disabled?: boolean;
    icon?: string;
    label?: string;
    path?: string | any[] | PathFunction;
    action?: any;
    cy?: string;
    payload?: any;
    permissionArea: PermissionArea;

    constructor(props = {}) {
        Object.assign(this, props);
    }

    getAction(payload?): any[] {
        if (!this.action) {
            return undefined;
        }
        return typeof this.action === 'function'
            ? this.action(payload)
            : this.action;
    }

    getPath(payload = this.payload): any[] {
        if (!this.path) {
            return undefined;
        }
        let path = typeof this.path === 'function'
            ? this.path(payload)
            : this.path;
        if (!Array.isArray(path)) {
            path = [path];
        }
        return path;
    }
}
